










































































import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { Component, Prop, Vue } from 'vue-property-decorator'

import { Credentials } from '@/models'

@Component({
  components: {
    ValidationObserver,
    ValidationProvider
  }
})
export default class LoginForm extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isLocked!: boolean

  isValid = false

  email = ''
  password = ''

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  setIsValid (valid: boolean) {
    this.isValid = valid
  }

  submit () {
    if (!this.isValid) {
      return
    }

    const credentials: Credentials = {
      user: this.email,
      password: this.password
    }

    this.$emit('submit', credentials)
  }
}
